export const webpOf = (src) =>
  src && src.startsWith("/images/products/") && src.endsWith(".jpg") ? src.replace(/\.jpg$/, ".webp") : null;

export const sizedImage = (src, w) => {
  if (src && src.startsWith("/api/images/")) {
    const base = src.split("?")[0];
    return `${base}.webp?w=${w}`;
  }
  return src;
};

export const mainSrc = (src, w = 1400) => {
  if (src && src.startsWith("/api/images/")) return sizedImage(src, w);
  return webpOf(src) || src;
};

export const displaySrc = (src) =>
  src && src.startsWith("/api/images/") ? sizedImage(src, 900) : webpOf(src) || src;

export const ProductImg = ({ src, alt = "", className = "", w, eager = false, draggable, ...rest }) => {
  const webp = webpOf(src);
  const finalSrc = w ? sizedImage(src, w) : src;
  const imgProps = {
    alt,
    className,
    loading: eager ? "eager" : "lazy",
    decoding: "async",
    ...rest,
    ...(eager ? { fetchPriority: "high" } : {}),
    ...(draggable !== undefined ? { draggable } : {}),
  };
  if (webp) {
    return (
      <picture>
        <source srcSet={webp} type="image/webp" />
        <img src={src} {...imgProps} />
      </picture>
    );
  }
  return <img src={finalSrc} {...imgProps} />;
};
